export default __webpack_public_path__ + "static/media/backpack.2f375220.png";